import {ref} from 'vue'
import {defineStore} from 'pinia'
import {clientApi} from '@/api'
import type {CardsDashboardResponse} from '@shared/types'

export const useDashboardStore = defineStore('dashboard', () => {
  const data = ref<CardsDashboardResponse | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  let requestGeneration = 0

  async function fetchDashboard(profileId: number) {
    const generation = ++requestGeneration
    isLoading.value = true
    error.value = null
    try {
      const response = await clientApi.cards.getDashboard(profileId)
      if (generation === requestGeneration) data.value = response
    } catch (e) {
      if (generation === requestGeneration) {
        error.value = e instanceof Error ? e.message : 'Failed to load dashboard'
      }
    } finally {
      if (generation === requestGeneration) isLoading.value = false
    }
  }

  function reset() {
    requestGeneration++
    data.value = null
    error.value = null
    isLoading.value = false
  }

  return {data, isLoading, error, fetchDashboard, reset}
})
